import CachedApi from "@/commons/CachedApi.js";
import Http from "@/commons/Http.js";

const path = 'api/v2/regras-estaduais';

export default {

  async getCustaAbatimentoRO(protocolo){
    return CachedApi.getCached('ro-custa-abatimento-'+protocolo, async () => {
      return Http.get(`${path}/RO/abatimento/${protocolo}`);
    });
  },

  async getSaldoProvisionadoSP(protocolo){
    return CachedApi.getCached('sp-saldo-provisionado-'+protocolo, async () => {
      return Http.get(`${path}/RO/abatimento/${protocolo}`);
    });
  },

  async getDisponivelRestituicaoSP(protocolo){
    return Http.get(`${path}/SP/disponivel-restituicao/${protocolo}`);
  },

  async gerarDajeBahia(protocolo, dto){
    return Http.post(`${path}/BA/${protocolo}/daje`, dto);
  },

  async capturarDajesAtoBA(ato){
    return Http.get(`${path}/BA/dajes-ato/${ato}`);
  },

  async listarMotivoIsencaoBA(){
    return Http.get(`${path}/BA/motivo-isencao`);
  },

  async listarMotivoCancelamentoBA(){
    return Http.get(`${path}/BA/motivo-cancelamento`);
  },

  async suportaOutorgantesRI(){
    return CachedApi.getCached('sp-suporta-outorgantes-ri', async () => {
      return Http.get(`${path}/suporta-outorgantes-ri`);
    });
  },

  async exibeAbaAtosPreRegistroRtdRcpj(){
    return CachedApi.getCached('exibe-aba-atos-pre-registro-rtd-rcpj', async () => {
      return Http.get(`${path}/exibe-aba-atos-pre-registro-rtd-rcpj`);
    });
  },

  async importarSelosTJMG(file, sessionKey) {

    const formData = new FormData();
    formData.append("file", file);
    if(sessionKey){
      formData.append("sessionKey", sessionKey);
    }

    let config = {
      timeout: 0,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    };

    return Http.post(`${path}/MG/importar-selos-criptografados`, formData, config);
  }
}
